import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SiteGet } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-sites-api-client';
import { Subscription } from 'rxjs';
import { ThemeModeService } from 'src/app/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';

@Component({
  selector: 'app-site-select',
  templateUrl: './site-select.component.html',
  styleUrls: ['./site-select.component.scss']
})
export class SiteSelectComponent implements OnInit {
  @Input() sites: SiteGet[] = [];
  @Input() selectedSite: SiteGet;
  @Output() siteChange = new EventEmitter<SiteGet>();

  private subscriptions: Subscription[] = [];
  darkMode: boolean = false;
  dropdownOpen = false;

  constructor(
    private modeService: ThemeModeService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(this.modeService.mode.asObservable().subscribe((mode) => {
      this.darkMode = mode === 'dark';
    }));
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectSite(site: SiteGet) {
    this.selectedSite = site;
    this.siteChange.emit(site);
    this.dropdownOpen = false;
  }

  getFlag(site: SiteGet): string {
    return '../../../../../assets/media/flags/' + site.countryName!.toLowerCase().replace(' - ', '-').replace(' ', '-') + '.svg';
  }
}
